import { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIncludeNewMoscow } from 'shared/selectors/jsonQuery';

import { selectLocation } from 'shared/selectors/location';
import { useAppDispatch } from 'shared/hooks';
import { selectDistrictsSwitcher } from 'shared/selectors/geo';
import { setIncludeNewMoscow } from 'shared/slices/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { loadDistrictsTree, removeDistrict, selectDistrict } from 'shared/thunks/geo/districtsSwitcher';
import { trackOpenDistrictsModalEvent } from '../PopupButtonContainer/tracking';
import { DistrictsV2 } from '../../../../../../packages/GeoComponents/shared/components/DistrictsModal/DistrictsV2';

export const DistrictsModalContainerV2: FC = () => {
  const dispatch = useAppDispatch();
  const currentLocation = useSelector(selectLocation);
  const includeNewMoscow = useSelector(selectIncludeNewMoscow);
  const { isLoading, districts, selectedDistricts } = useSelector(selectDistrictsSwitcher);

  const handleSelect = useCallback(
    (id: number, name: string) => {
      dispatch(selectDistrict({ id, name }));
    },
    [dispatch],
  );

  const handleRemove = useCallback(
    (id: number) => {
      dispatch(removeDistrict(id));
    },
    [dispatch],
  );

  const handleNewMoscowSwitched = useCallback(
    (includeNewMoscow: boolean | null) => {
      dispatch(setIncludeNewMoscow(includeNewMoscow));
      dispatch(updateSearchMeta());
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(loadDistrictsTree());
    trackOpenDistrictsModalEvent();
  }, [dispatch]);

  return (
    <DistrictsV2
      isRedesign
      selectedLocation={currentLocation}
      isDataLoading={isLoading}
      districts={districts}
      selectedDistricts={selectedDistricts}
      includeNewMoscow={includeNewMoscow}
      onNewMoscowSwitched={handleNewMoscowSwitched}
      onRemoved={handleRemove}
      onSelected={handleSelect}
    />
  );
};
